import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_MARKUP } from "@/lib/solitairePricing";

const Ctx = createContext(null);

export const SolitaireSettingsProvider = ({ children }) => {
  const [usdRate, setUsdRate] = useState(83);
  const [markupKey, setMarkupKey] = useState(DEFAULT_MARKUP);
  const [gstOn, setGstOn] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/solitaires/usd-rate");
        if (data?.rate) setUsdRate(Number(data.rate));
      } catch (err) {
        console.error("[SolitaireSettings] USD rate fetch failed:", err);
        /* keep 83 fallback */
      }
    })();
  }, []);

  return (
    <Ctx.Provider value={{ usdRate, setUsdRate, markupKey, setMarkupKey, gstOn, setGstOn }}>
      {children}
    </Ctx.Provider>
  );
};

export const useSolitaireSettings = () => useContext(Ctx) || { usdRate: 83, markupKey: DEFAULT_MARKUP, gstOn: false, setMarkupKey: () => {}, setGstOn: () => {} };
